'use client';

import React from 'react';
import ErrorBoundary from '@/components/common/error-boundary/ErrorBoundary';

const ErrorPage = (props: {
  error: Error & { digest?: string; };
}) => (
  <ErrorBoundary error={props.error} />
);

export default ErrorPage;
